export default "__VITE_ASSET__DS5o$Crm__"